var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInputContainer',{attrs:{"inputId":`I${_vm._uid}`,"label":_vm.label,"errors":_vm.errors}},[_c('textarea',_vm._g(_vm._b({attrs:{"id":`I${_vm._uid}`},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),{ [_vm.lazy ? 'change' : 'input']: _vm.handleInput }))])
}
var staticRenderFns = []

export { render, staticRenderFns }